import {SC_User} from "../SC_User";

export class SC_EmployeeFilter {
    public name: string | null;
    public pcid: number | null;
    public managerID: number | null;

    constructor({
                    name = null,
                    pcid = null,
                    managerID = null,
                } = {}) {
        this.name = name;
        this.pcid = pcid;
        this.managerID = managerID;
    }

    toAPI(): Record<string, unknown> {
        return {
            name: this.name,
            pcid: this.pcid,
            managerID: this.managerID,
        };
    }

    static fromURL(params: URLSearchParams): SC_EmployeeFilter {
        const out = new SC_EmployeeFilter();

        if (params.has("location_name"))
            out.name = params.get("location_name");

        if (params.has("pcid"))
            out.pcid = Number(params.get("pcid") || "0");

        if (params.has("managerID"))
            out.managerID = Number(params.get("managerID") || "0");

        return out;
    }

    toURL(params: URLSearchParams): URLSearchParams {
        if (this.name === null || this.name === "")
            params.delete("location_name");
        else
            params.set("location_name", this.name);

        if (this.pcid === null || !this.pcid)
            params.delete("pcid");
        else
            params.set("pcid", this.pcid.toString());

        if (this.managerID === null || !this.managerID)
            params.delete("managerID");
        else
            params.set("managerID", this.managerID.toString());

        return params;
    }

    clone(): SC_EmployeeFilter {
        const cloned = new SC_EmployeeFilter();

        cloned.name = this.name;
        cloned.pcid = this.pcid;
        cloned.managerID = this.managerID;

        return cloned;
    }

    /**
     * Merges another SC_EmployeeFilter object into this one, replacing null fields
     */
    merge(other: SC_EmployeeFilter): SC_EmployeeFilter {
        if (other.name !== null) this.name = other.name;
        if (other.pcid !== null) this.pcid = other.pcid;
        if (other.managerID !== null) this.managerID = other.managerID;

        return this;
    }

    applyToFormData(formData: FormData): void {
        if (this.name)
            formData.append("name", this.name);
        if (this.pcid !== null)
            formData.append("pcid", this.pcid.toString());
        if (this.managerID !== null)
            formData.append("managerID", this.managerID.toString());
    }

    applyToUser(user: SC_User): boolean {
        if (this.name && this.name.length)
            if (!user.name.toLowerCase().includes(this.name.toLowerCase()))
                return false;

        if (this.pcid !== null && this.pcid)
            if (user.paycomID !== this.pcid)
                return false;

        if (this.managerID)
            if (!(user?.managerIDs?.includes(this.managerID) ?? false))
                return false;

        return true;
    }
}